<template lang="pug">
  .sidebar(:class="{ open: openSidebar }")
    .search.search-job
      .search-menu
        .search-title
          span 絞り込む
        .search-row
          span.search-label 掲載状況
          select(v-if="fixedViewEndDate" v-model="viewEndDate")
            option(v-for="option in defaultViewEndDate" :value="option.code") {{ option.name }}
          select(v-else v-model="viewEndDate")
            option(v-for="option in postingSituations" :value="option.code") {{ option.name }}
        .search-row
          span.search-label 掲載開始日
          select(v-model="acquisitionDate")
            option(v-for="option in acquisitionDates" :value="option.code") {{ option.name }}
        .search-row(v-if="this.$store.state.searchJob.query.acquisitionDate == 4")
          span.search-label(v-if="fixedViewEndDate")
            | 掲載開始日の期間(最大180日間)
          span.search-label(v-else)
            | 掲載開始日の期間
          .acquisition-datepicker
            datepicker(
              v-model="fromAcquisitionDate"
              :format="customFormatter"
              :language="ja"
              :disabled-dates="fromAcquisitionDisabledDates"
              wrapper-class="calender-text-box-wrapper"
              input-class="calender-text-box"
              @closed="pickerClosedChange"
            )
            span 〜
            datepicker(
              v-model="toAcquisitionDate"
              :format="customFormatter"
              :language="ja"
              :disabled-dates="toAcquisitionDisabledDates"
              wrapper-class="calender-text-box-wrapper"
              input-class="calender-text-box"
              @closed="pickerClosedChange"
            )
        .search-row
          span.search-label 掲載メディア
          MultipleSelect(v-model="mediaCd" :options="haken ? vSelectHakenMedia : vSelectMedia")
        .search-row
          span.search-label 出稿金額
          label
            select.select-short(v-model="budgetLower")
              option(v-for="option in budgets" :value="option.code") {{ option.name }}
            span 〜
          label
            select.select-short(v-model="budgetUpper")
              option(v-for="option in budgets" :value="option.code") {{ option.name }}
        .search-row(v-if="!haken")
          span.search-label 所在地
          .select-tree(:class="{ active: openPrefectureModal }")
            a.select-tree-button(
              @click="togglePrefectureModal"
              :class="{ active: openPrefectureModal }")
              | 選択する
            span.select-tree-selected(v-if="prefectureCd.length > 0 || cityCd.length > 0") 選択中
            PrefectureCityModal(
              :groupingPrefecture="true"
              :prefectures="this.$store.state.master.prefectures"
              :openPrefectureCityModal="openPrefectureModal"
              :selectedPrefectureCd="prefectureCd"
              :selectedCityCd="cityCd"
              @setPrefectures="setPrefectureCodes"
              @setPrefectureCities="setCityCodes"
              @hide="hidePrefectureModal")
        .search-row(v-if="!haken")
          span.search-label 最寄駅
          .search-keyword-suggest(:class="{ active: showSearchStations }")
            label.text
              input(
                type="text",
                v-model="stationName",
                placeholder="",
                @keydown="keydownCondition"
                @keyup="keyupStation")
            ul(v-if="showSearchStations")
              li(v-for="option in filteredStations")
                a(@click="selectStation(option)") {{ option.display_name }}
        .search-row
          span.search-label 勤務地
          .select-tree(:class="{ active: openWorkPlacePrefectureModal }")
            a.select-tree-button(
              @click="toggleWorkPlacePrefectureModal"
              :class="{ active: openWorkPlacePrefectureModal }")
              | 選択する
            span.select-tree-selected(v-if="workPlacePrefectureCd.length > 0 || workPlaceCityCd.length > 0") 選択中
            PrefectureCityModal(
              :groupingPrefecture="true"
              :prefectures="this.$store.state.master.prefectures"
              :openPrefectureCityModal="openWorkPlacePrefectureModal"
              :selectedPrefectureCd="workPlacePrefectureCd"
              :selectedCityCd="workPlaceCityCd"
              @setPrefectures="setWorkPlacePrefectureCodes"
              @setPrefectureCities="setWorkPlaceCityCodes"
              @hide="hideWorkPlacePrefectureModal")
        .search-row
          span.search-label 職種
          .select-tree(:class="{ active: openJobtypeModal }")
            a.select-tree-button(
              @click="toggleJobtypeModal"
              :class="{ active: openJobtypeModal }")
              | 選択する
            span.select-tree-selected(v-if="jobtypeCd.length > 0") 選択中
            JobtypeModal(
              :openJobtypeModal="openJobtypeModal"
              :selectedJobtypeCd="this.$store.state.searchJob.query.jobtypeCd"
              :filteredAp="false"
              @setJobtypeCodes="setJobtypeCodes"
              @hide="hideJobtypeModal")
        .search-row
          span.search-label 業種
          MultipleSelect(v-model="industryCd" :options="haken ? vSelectHakenIndustry : vSelectIndustry")
        .search-row
          span.search-label 特徴
          MultipleSelect(v-model="prPointCd" :options="vSelectPrPoint")
        template(v-if="!haken")
          .search-row
            label.checkbox
              input(type="checkbox"
                v-model="selectedIntroductionCompany"
                true-value="true"
                false-value="false")
              span 人材紹介・エージェントを省く
          .search-row
            label.checkbox
              input(type="checkbox"
                v-model="excludedTemporaryStaffing"
                true-value="true"
                false-value="false")
              span 派遣会社を省く
        .search-row
          label.checkbox
            input(type="checkbox"
              v-model="excludedNoCompanyTel"
              true-value="true"
              false-value="false")
            span 電話番号なしを省く
        .search-row
          label.checkbox
            input(type="checkbox"
              v-model="excludedNoCompanyUrl"
              true-value="true"
              false-value="false")
            span 企業URLなしを省く

        .search-row(ref="salaryRow")
          span.search-label 給与
          label.radio
            input(type="radio" value="0" v-model="salaryCd")
            span すべて
          br
          label.radio(v-for="salaryType in salaryTypes")
            input(type="radio" :value="salaryType.code" v-model="salaryCd")
            span {{ salaryType.name }}
          br
          template(v-if="salaryCd !== '0'")
            label
              select.select-short(v-model="salaryMin")
                option(v-for="option in salaryValues[salaryCd]" :value="option.code")
                  | {{ option.name }}
              span 〜
            label
              select.select-short(v-model="salaryMax")
                option(v-for="option in salaryValues[salaryCd]" :value="option.code")
                  | {{ option.name }}
        .search-row
          span.search-label 雇用形態
          MultipleSelect(v-model="employmentCd" :options="haken ? vSelectHakenEmploymentCd : vSelectEmploymentCd")
        .search-row
          span.search-label {{ haken ? '派遣先候補の事業所名' : '事業所名' }}
          label.text
            input(
              type="text"
              v-model="companyName"
              placeholder="例）株式会社XXXX"
              @keydown="keydownCondition"
              @keyup="keyupCondition")
        .search-row
          span.search-label キーワードその他({{ this.maxKeywords }}個まで)
          span.keyword-info 改行でキーワードを追加
          .keyword-tag-area
            .select-choice(:class="keyword.length > 0 ? 'open' : ''")
              ul.select-choice-selected
                li(v-for="(tag, index) in this.keyword")
                  div {{ tag }}
                  a.select-choice-delete(@click="removeKeyword(index)")
          label.text
            input(
              type="text"
              placeholder="例）仕事内容、資格など"
              @keydown="keydownCondition"
              @keyup.enter="keywordEnter($event)")
          span.search-label-sub 適用項目
          label.checkbox.sub
            input(type="checkbox"
              v-model="applyKeywordsToCatchcopy"
              true-value="true"
              false-value="false")
            span キャッチコピー
          label.checkbox.sub
            input(type="checkbox"
              v-model="applyKeywordsToJobtypeName"
              true-value="true"
              false-value="false")
            span 募集職種
          label.checkbox.sub
            input(type="checkbox"
              v-model="applyKeywordsToJobContents"
              true-value="true"
              false-value="false")
            span 仕事内容
          label.checkbox.sub
            input(type="checkbox"
              v-model="applyKeywordsToQualification"
              true-value="true"
              false-value="false")
            span 応募資格
          label.checkbox.sub
            input(type="checkbox"
              v-model="applyKeywordsToCompanyName"
              true-value="true"
              false-value="false")
            span 事業所名
        .search-row
          span.search-label 除外キーワード({{ this.maxKeywords }}個まで)
          span.keyword-info 改行でキーワードを追加
          .keyword-tag-area
            .select-choice(:class="excludeKeyword.length > 0 ? 'open' : ''")
              ul.select-choice-selected
                li(v-for="(tag, index) in this.excludeKeyword")
                  div {{ tag }}
                  a.select-choice-delete(@click="removeExcludeKeyword(index)")
          label.text
            input(
              type="text"
              placeholder="例）除外したい仕事内容、資格など"
              @keydown="keydownCondition"
              @keyup.enter="excludeKeywordEnter($event)")
          .keyword
            a.keyword-button(@click="applyRecommendedExcludeKeywords")
              | おすすめキーワードを設定する
          span.search-label-sub 適用項目
          label.checkbox.sub
            input(type="checkbox"
              v-model="applyExcludeKeywordsToCatchcopy"
              true-value="true"
              false-value="false")
            span キャッチコピー
          label.checkbox.sub
            input(type="checkbox"
              v-model="applyExcludeKeywordsToJobtypeName"
              true-value="true"
              false-value="false")
            span 募集職種
          label.checkbox.sub
            input(type="checkbox"
              v-model="applyExcludeKeywordsToJobContents"
              true-value="true"
              false-value="false")
            span 仕事内容
          label.checkbox.sub
            input(type="checkbox"
              v-model="applyExcludeKeywordsToQualification"
              true-value="true"
              false-value="false")
            span 応募資格
          label.checkbox.sub
            input(type="checkbox"
              v-model="applyExcludeKeywordsToCompanyName"
              true-value="true"
              false-value="false")
            span 事業所名
        .search-row
          span.search-label {{ haken ? '派遣先候補の事業所ID' : '事業所ID' }}
          label.text
            input(
              type="text"
              v-model="companyId"
              placeholder="半角英数字のみ"
              @keydown="keydownCondition"
              @keyup="keyupCondition")
        .search-row(v-if="haken")
          span.search-label 派遣元企業名
          label.text
            input(
              type="text"
              v-model="hakenCompanyName"
              placeholder="例）株式会社XXXX"
              @keydown="keydownCondition"
              @keyup="keyupCondition")
      .search-button
        input.button-main(
          type="button"
          @click="search"
          value="検索する"
          :disabled="locked")
        input.button-secondary(
          type="button"
          @click="toSearchConditions"
          value="保存した条件"
          :disabled="locked")
        span
          a(@click="clear") クリア
        span
          a(@click="showSearchConditionModal") 条件を保存
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex'
  import Datepicker from 'vuejs-datepicker'
  import { ja } from 'vuejs-datepicker/dist/locale'
  import moment from 'moment'
  import {
    acquisitionDates,
    budgets,
    postingSituations,
    salaryTypes,
    salaryValues,
    DefaultViewEndCode,
    DefaultAcquisitionDateCode,
    DefaultSalaryTypeCode,
    DefaultIntroductionCompany,
    DefaultSearchJobQuery,
    DefaultExcludedNoCompanyTel,
    DefaultExcludedNoCompanyUrl,
    DefaultApplyKeywordsToCatchcopy,
    DefaultApplyKeywordsToJobtypeName,
    DefaultApplyKeywordsToJobContents,
    DefaultApplyKeywordsToQualification,
    DefaultApplyKeywordsToCompanyName,
    DefaultApplyExcludeKeywordsToCatchcopy,
    DefaultApplyExcludeKeywordsToJobtypeName,
    DefaultApplyExcludeKeywordsToJobContents,
    DefaultApplyExcludeKeywordsToQualification,
    DefaultApplyExcludeKeywordsToCompanyName,
    DefaultOrder,
    DefaultOrderDirection,
    maxKeywords,
    recommendedExcludeKeywords,
  } from '../../constants'
  import { api } from '../../libs/api'
  import mapGetSet from '../../libs/map-get-set'
  import searchJob from '../../store/modules/searchJob'
  import JobtypeModal from '../parts/JobtypeModal'
  import MultipleSelect from '../parts/MultipleSelect'
  import PrefectureCityModal from '../parts/PrefectureCityModal'

  export default {
    components: { JobtypeModal, MultipleSelect, PrefectureCityModal, Datepicker },
    props: ['openSidebar', 'fixedViewEndDate', 'focusSalaryNonce'],
    beforeCreate () {
      this.acquisitionDates = acquisitionDates
      this.budgets = budgets
      this.postingSituations = postingSituations
      this.salaryTypes = salaryTypes
      this.salaryValues = salaryValues
      this.maxKeywords = maxKeywords
    },
    data () {
      const {
        acquisitionDate = DefaultAcquisitionDateCode,
        budgetLower = '',
        budgetUpper = '',
        cityCd = '',
        companyId = '',
        companyName = '',
        hakenCompanyName = '',
        employmentCd = '',
        industryCd = '',
        jobtypeCd = '',
        keyword = '',
        excludeKeyword = '',
        mediaCd = '',
        prefectureCd = '',
        prPointCd = '',
        salaryCd = DefaultSalaryTypeCode,
        salaryMin = '',
        salaryMax = '',
        selectedIntroductionCompany = DefaultIntroductionCompany,
        excludedTemporaryStaffing = DefaultIntroductionCompany,
        excludedNoCompanyTel = DefaultExcludedNoCompanyTel,
        excludedNoCompanyUrl = DefaultExcludedNoCompanyUrl,
        applyKeywordsToCatchcopy = DefaultApplyKeywordsToCatchcopy,
        applyKeywordsToJobtypeName = DefaultApplyKeywordsToJobtypeName,
        applyKeywordsToJobContents = DefaultApplyKeywordsToJobContents,
        applyKeywordsToQualification = DefaultApplyKeywordsToQualification,
        applyKeywordsToCompanyName = DefaultApplyKeywordsToCompanyName,
        applyExcludeKeywordsToCatchcopy = DefaultApplyExcludeKeywordsToCatchcopy,
        applyExcludeKeywordsToJobtypeName = DefaultApplyExcludeKeywordsToJobtypeName,
        applyExcludeKeywordsToJobContents = DefaultApplyExcludeKeywordsToJobContents,
        applyExcludeKeywordsToQualification = DefaultApplyExcludeKeywordsToQualification,
        applyExcludeKeywordsToCompanyName = DefaultApplyExcludeKeywordsToCompanyName,
        stationId = '',
        viewEndDate = DefaultViewEndCode,
        workPlacePrefectureCd = '',
        workPlaceCityCd = '',
        fromAcquisitionDate = this.setDefaultFromAcquisitionDate(),
        toAcquisitionDate = this.setDefaultToAcquisitionDate(),
        order = DefaultOrder,
        orderDirection = DefaultOrderDirection,
      } = this.$route.query

      // query parameter initialization
      const master = this.$store.state.master
      this.acquisitionDate = acquisitionDate
      this.budgetLower = budgetLower
      this.budgetUpper = budgetUpper
      this.cityCd = this.toObjects(cityCd, master.cities)
      this.companyId = companyId
      this.companyName = companyName
      this.hakenCompanyName = hakenCompanyName
      this.employmentCd = this.toObjects(employmentCd, master.employments)
      this.industryCd = this.toObjects(industryCd, master.industries)
      this.jobtypeCd = this.toObjects(jobtypeCd, master.jobtypes)
      this.keyword = this.toKeywordObjects(keyword)
      this.excludeKeyword = this.toExcludeKeywordObjects(excludeKeyword)
      this.mediaCd = this.toObjects(mediaCd, master.mediaForJobs)
      this.prefectureCd = this.toObjects(prefectureCd, master.prefectures)
      this.prPointCd = this.toObjects(prPointCd, master.prPoints)
      this.salaryCd = salaryCd
      this.salaryMin = salaryMin
      this.salaryMax = salaryMax
      this.selectedIntroductionCompany = selectedIntroductionCompany
      this.excludedTemporaryStaffing = excludedTemporaryStaffing
      this.excludedNoCompanyTel = excludedNoCompanyTel
      this.excludedNoCompanyUrl = excludedNoCompanyUrl
      this.applyKeywordsToCatchcopy = applyKeywordsToCatchcopy
      this.applyKeywordsToJobtypeName = applyKeywordsToJobtypeName
      this.applyKeywordsToJobContents = applyKeywordsToJobContents
      this.applyKeywordsToQualification = applyKeywordsToQualification
      this.applyKeywordsToCompanyName = applyKeywordsToCompanyName
      this.applyExcludeKeywordsToCatchcopy = applyExcludeKeywordsToCatchcopy
      this.applyExcludeKeywordsToJobtypeName = applyExcludeKeywordsToJobtypeName
      this.applyExcludeKeywordsToJobContents = applyExcludeKeywordsToJobContents
      this.applyExcludeKeywordsToQualification = applyExcludeKeywordsToQualification
      this.applyExcludeKeywordsToCompanyName = applyExcludeKeywordsToCompanyName
      this.stationId = stationId
      this.viewEndDate = viewEndDate
      this.workPlacePrefectureCd = this.toObjects(workPlacePrefectureCd, master.prefectures)
      this.workPlaceCityCd = this.toObjects(workPlaceCityCd, master.cities)
      this.fromAcquisitionDate = fromAcquisitionDate
      this.toAcquisitionDate = toAcquisitionDate
      this.haken = this.$route.name === 'SearchHaken' || this.$route.name === 'SearchGroupingHaken'
      this.order = order
      this.orderDirection = orderDirection

      if (this.$route.query.stationId) {
        api.fetchStation({ id: this.$route.query.stationId })
          .then((res) => {
            if (res) {
              this.stationName = res[0].name
            }
          })
      } else {
        this.stationName = ''
      }

      // グルーピング時の掲載状況の選択肢出し分け
      if (this.fixedViewEndDate && acquisitionDate === '4') {
        this.defaultViewEndDate = postingSituations.filter(option => ['0', '1', '2', '3', '4'].includes(option.code))
      } else {
        this.defaultViewEndDate = postingSituations.filter(option => ['1', '2', '3', '4'].includes(option.code))
      }

      return {
        filteredStations: [],
        openJobtypeModal: false,
        openPrefectureModal: false,
        openWorkPlacePrefectureModal: false,
        keyDownCode: '',
        timeoutId: null,
        ja,
        fromAcquisitionDisabledDates: {
          to: toAcquisitionDate && this.fixedViewEndDate ? new Date(moment(toAcquisitionDate).subtract(180, 'd').format('YYYY-MM-DD')) : '',
          from: toAcquisitionDate ? new Date(moment(toAcquisitionDate).format('YYYY-MM-DD')) : '',
        },
        toAcquisitionDisabledDates: {
          to: fromAcquisitionDate ? new Date(moment(fromAcquisitionDate).format('YYYY-MM-DD')) : '',
          from: fromAcquisitionDate && this.fixedViewEndDate ? new Date(moment(fromAcquisitionDate).add(180, 'd').format('YYYY-MM-DD')) : '',
        },
      }
    },
    computed: {
      ...mapGetters({
        apiQuery: 'searchJob/apiQuery',
        locked: 'common/isGlobalLocked',
      }),
      vSelectMedia () {
        return this.$store.state.master.mediaForJobs.map(m => ({ label: m.name, value: m.code }))
      },
      vSelectHakenMedia () {
        return this.$store.state.master.mediaForJobs.filter(m => ![14, 15, 16].includes(m.code)).map(m => ({ label: m.name, value: m.code }))
      },
      vSelectIndustry () {
        return this.$store.state.master.industries.map(i => ({ label: i.name, value: i.code }))
      },
      vSelectHakenIndustry () {
        return this.$store.state.master.industries.filter(i => i.code !== 23).map(i => ({ label: i.name, value: i.code }))
      },
      vSelectPrPoint () {
        return this.$store.state.master.prPoints.map(pp => ({ label: pp.name, value: pp.code }))
      },
      vSelectEmploymentCd () {
        return this.$store.state.master.employments.map(e => ({ label: e.name, value: e.code }))
      },
      vSelectHakenEmploymentCd () {
        return this.vSelectEmploymentCd.filter(e => ![3, 4].includes(e.value))
      },
      ...mapGetSet({
        _this: this,
        get: ($vm, $s, k) => $s.state.searchJob.query[k],
        set: ($vm, $s, k, v) => $s.commit(`searchJob/${k}`, v),
        keys: Object.keys(searchJob.state.query),
      }),
      showSearchStations () {
        return this.filteredStations.length > 0
      },
      formattedStationName () {
        return this.stationName.replace(/^\(.*\)/g, '')
      },
    },
    watch: {
      $route () {
        Object.assign(this.$data, this.$options.data.apply(this))
      },
      // 求人一覧の給与列ヘッダーから「給与種別を選んでほしい」と要求されたとき
      focusSalaryNonce (nonce) {
        if (!nonce) return
        this.$nextTick(() => {
          const row = this.$refs.salaryRow
          if (row && row.scrollIntoView) row.scrollIntoView({ block: 'center' })
        })
      },
      salaryCd (newSalaryCd) {
        if (this.salaryValues[newSalaryCd].indexOf(this.salaryMin) < 0) {
          this.salaryMin = ''
        }
        if (this.salaryValues[newSalaryCd].indexOf(this.salaryMax) < 0) {
          this.salaryMax = ''
        }
      },
      acquisitionDate (newAcquisitionDate) {
        // グルーピングの場合、掲載開始日によって掲載状況の選択肢を変える。
        if (this.fixedViewEndDate && newAcquisitionDate === '4') {
          this.defaultViewEndDate = postingSituations.filter(option => ['0', '1', '2', '3', '4'].includes(option.code))
        } else if (this.fixedViewEndDate) {
          this.defaultViewEndDate = postingSituations.filter(option => ['1', '2', '3', '4'].includes(option.code))
          // 掲載状況が全ての場合に現在掲載中を設定
          if (this.viewEndDate === '0') this.viewEndDate = DefaultViewEndCode
        }
      },
    },
    methods: {
      ...mapMutations('job', ['uncheckAll']),
      clear () {
        const { name } = this.$route
        this.uncheckAll()
        this.$emit('toggleSidebar')
        const query = {
          ...DefaultSearchJobQuery,
          perPage: String(this.$store.state.user.detail.jobs_per_page),
          page: '1',
          _t: new Date().getTime(),
        }
        this.$router.push({ name, query })
      },
      hideJobtypeModal () {
        this.openJobtypeModal = false
      },
      hidePrefectureModal () {
        this.openPrefectureModal = false
      },
      hideWorkPlacePrefectureModal () {
        this.openWorkPlacePrefectureModal = false
      },
      async keydownCondition (e) {
        this.keyDownCode = e.which
      },
      async keyupCondition (e) {
        // Enter押下時に検索する。keyDownCode持ってるのは日本語変換のEnterを無視するため
        if (e.which === 13 && e.which === this.keyDownCode) {
          this.search()
        }
      },
      async keyupStation () {
        clearTimeout(this.timeoutId)
        this.timeoutId = setTimeout(() => {
          if (this.stationName) {
            api.fetchStations({ stationName: this.formattedStationName })
              .then((res) => {
                this.filteredStations = res
              })
          } else {
            this.stationId = ''
            this.filteredStations = []
          }
        }, 500)
      },
      selectStation (station) {
        this.stationId = station.id
        this.stationName = station.display_name
        this.filteredStations = []
      },
      async showSearchConditionModal (e) {
        e.stopPropagation()
        const condition = {
          acquisitionDate: this.acquisitionDate,
          viewEndDate: this.viewEndDate,
          budgetLower: this.budgetLower,
          budgetUpper: this.budgetUpper,
          mediaCd: this.mediaCd.map(({ value }) => value),
          prefectureCd: this.prefectureCd.map(({ value }) => value),
          cityCd: this.cityCd.map(({ value }) => value),
          workPlacePrefectureCd: this.workPlacePrefectureCd.map(({ value }) => value),
          workPlaceCityCd: this.workPlaceCityCd.map(({ value }) => value),
          jobtypeCd: this.jobtypeCd.map(({ value }) => value),
          industryCd: this.industryCd.map(({ value }) => value),
          prPointCd: this.prPointCd.map(({ value }) => value),
          selectedIntroductionCompany: this.selectedIntroductionCompany,
          excludedTemporaryStaffing: this.excludedTemporaryStaffing,
          excludedNoCompanyTel: this.excludedNoCompanyTel,
          excludedNoCompanyUrl: this.excludedNoCompanyUrl,
          applyKeywordsToCatchcopy: this.applyKeywordsToCatchcopy,
          applyKeywordsToJobtypeName: this.applyKeywordsToJobtypeName,
          applyKeywordsToJobContents: this.applyKeywordsToJobContents,
          applyKeywordsToQualification: this.applyKeywordsToQualification,
          applyKeywordsToCompanyName: this.applyKeywordsToCompanyName,
          applyExcludeKeywordsToCatchcopy: this.applyExcludeKeywordsToCatchcopy,
          applyExcludeKeywordsToJobtypeName: this.applyExcludeKeywordsToJobtypeName,
          applyExcludeKeywordsToJobContents: this.applyExcludeKeywordsToJobContents,
          applyExcludeKeywordsToQualification: this.applyExcludeKeywordsToQualification,
          applyExcludeKeywordsToCompanyName: this.applyExcludeKeywordsToCompanyName,
          salaryCd: this.salaryCd,
          salaryMin: this.salaryMin,
          salaryMax: this.salaryMax,
          employmentCd: this.employmentCd.map(({ value }) => value),
          companyName: this.companyName,
          hakenCompanyName: this.hakenCompanyName,
          keyword: this.keyword,
          excludeKeyword: this.excludeKeyword,
          fromAcquisitionDate: this.fromAcquisitionDate,
          toAcquisitionDate: this.toAcquisitionDate,
          companyId: this.companyId,
          stationId: this.stationId,
          haken: this.haken,
        }
        this.$store.dispatch('searchCondition/fetchIndex')
        this.$store.dispatch('searchCondition/setConditions', { condition })
        this.$store.commit('searchCondition/showSearchConditionModal')
      },
      async search () {
        const { name, query } = this.$route
        this.$store.commit('common/lockGlobal')
        this.uncheckAll()
        try {
          const nextQuery = {
            ...this.apiQuery,
            perPage: query.perPage,
            page: '1',
            _t: Date.now(),
          }
          // 給与ソート中に給与種別を「すべて」へ戻すと並び順を再現できないため既定へ戻す
          if (nextQuery.order === 'salary' && !salaryTypes.some(t => t.code === String(nextQuery.salaryCd))) {
            nextQuery.order = DefaultOrder
            nextQuery.orderDirection = DefaultOrderDirection
          }
          this.$router.push({ name, query: nextQuery })
        } finally {
          this.$emit('toggleSidebar')
          this.$store.commit('common/unlockGlobal')
        }
      },
      toSearchConditions () {
        this.$router.push({ name: 'SearchConditions' })
      },
      toggleJobtypeModal (e) {
        e.stopPropagation()
        this.openJobtypeModal = !this.openJobtypeModal
      },
      togglePrefectureModal (e) {
        e.stopPropagation()
        this.openPrefectureModal = !this.openPrefectureModal
      },
      toggleWorkPlacePrefectureModal (e) {
        e.stopPropagation()
        this.openWorkPlacePrefectureModal = !this.openWorkPlacePrefectureModal
      },
      applyRecommendedExcludeKeywords (e) {
        e.stopPropagation()
        this.excludeKeyword = this.toExcludeKeywordObjects(recommendedExcludeKeywords)
      },
      toObjects (ids, masterData) {
        if (!ids) {
          return []
        }

        const isNumber = typeof masterData[0].code === 'number'
        return ids.split(',').reduce((list, id) => {
          const data = isNumber ?
            masterData.find(d => d.code === Number(id)) :
            masterData.find(d => d.code === id)
          if (data) {
            list.push({ label: data.name, value: data.code })
          }
          return list
        }, [])
      },
      toExcludeKeywordObjects (words) {
        if (!words) {
          return []
        }
        return words.split(',')
      },
      toKeywordObjects (words) {
        if (!words) {
          return []
        }
        return words.split(',')
      },
      async setJobtypeCodes (jobtypeCodes) {
        this.openJobtypeModal = false
        this.jobtypeCd = jobtypeCodes
      },
      async setPrefectureCodes (prefectureCodes) {
        this.openPrefectureModal = false
        this.prefectureCd = prefectureCodes
      },
      async setCityCodes (cityCodes) {
        this.openPrefectureModal = false
        this.cityCd = cityCodes
      },
      async setWorkPlacePrefectureCodes (prefectureCodes) {
        this.openWorkPlacePrefectureModal = false
        this.workPlacePrefectureCd = prefectureCodes
      },
      async setWorkPlaceCityCodes (cityCodes) {
        this.openWorkPlacePrefectureModal = false
        this.workPlaceCityCd = cityCodes
      },
      setDefaultFromAcquisitionDate () {
        return moment(new Date()).subtract(30, 'd').format('YYYY-MM-DD')
      },
      setDefaultToAcquisitionDate () {
        return moment(new Date()).format('YYYY-MM-DD')
      },
      customFormatter (date) {
        return moment(date).format('YYYY-MM-DD')
      },
      pickerClosedChange () {
        if (this.fromAcquisitionDate) {
          this.fromAcquisitionDate = moment(this.fromAcquisitionDate).format('YYYY-MM-DD')
          this.toAcquisitionDisabledDates.to = new Date(moment(this.fromAcquisitionDate).format('YYYY-MM-DD'))

          // グルーピングの際にだけ180日に制限
          if (this.fixedViewEndDate) {
            this.toAcquisitionDisabledDates.from = new Date(moment(this.fromAcquisitionDate).add(180, 'd').format('YYYY-MM-DD'))
          }
        }

        if (this.toAcquisitionDate) {
          this.toAcquisitionDate = moment(this.toAcquisitionDate).format('YYYY-MM-DD')
          this.fromAcquisitionDisabledDates.from = new Date(moment(this.toAcquisitionDate).format('YYYY-MM-DD'))

          // グルーピングの際にだけ180日に制限
          if (this.fixedViewEndDate) {
            this.fromAcquisitionDisabledDates.to = new Date(moment(this.toAcquisitionDate).subtract(180, 'd').format('YYYY-MM-DD'))
          }
        }
      },
      excludeKeywordEnter (e) {
        if (e.which === 13 && e.which === this.keyDownCode) {
          if (typeof e.target.value === 'string' && e.target.value.trim() !== '') {
            this.addExcludeKeyword(e.target.value.trim())
            e.target.value = ''
          }
        }
      },
      keywordEnter (e) {
        if (e.which === 13 && e.which === this.keyDownCode) {
          if (typeof e.target.value === 'string' && e.target.value.trim() !== '') {
            this.addKeyword(e.target.value.trim())
            e.target.value = ''
          }
        }
      },
      addExcludeKeyword (str) {
        if (this.excludeKeyword.length === this.maxKeywords) {
          // eslint-disable-next-line no-alert
          return alert(`除外キーワードは${this.maxKeywords}個までです。`)
        }
        this.$store.commit('searchJob/addExcludeKeyword', str)
      },
      addKeyword (str) {
        if (this.keyword.length === this.maxKeywords) {
          // eslint-disable-next-line no-alert
          return alert(`キーワードは${this.maxKeywords}個までです。`)
        }
        this.$store.commit('searchJob/addKeyword', str)
      },
      removeExcludeKeyword (index) {
        this.$store.commit('searchJob/removeExcludeKeyword', index)
      },
      removeKeyword (index) {
        this.$store.commit('searchJob/removeKeyword', index)
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/JobSidebar.vue